
export default {
  components: {
    hotSiteMapBody: () => import('~/components/Organisms/SiteMapBody/SiteMapBody.vue'),
  },
}
